(function () {

    'use strict';

    angular.module('iplusjs.mapper.radioTrackBy', [
        'lodash'
    ])
    .directive('iplusjsRadioTrackBy', radioTrackBy);

    radioTrackBy.$inject = [
        'lodash'
    ];
    function radioTrackBy(_) {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                radioTrackBy: '@iplusjsRadioTrackBy',
                origValue: '=ngModel',
                ngValue: '='
            },
            link: function ($scope, $elem, $attr, $ngModelCtrl) {
                $scope.$watchCollection(function () {
                    if ($scope.origValue && _.get($scope.ngValue, $scope.radioTrackBy) === _.get($scope.origValue, $scope.radioTrackBy)) {
                        $scope.origValue = $scope.ngValue;
                    }
                }, function () {
                    $ngModelCtrl.$render();
                });
            }
        };
    }

})();
